import React from "react"
import { Spinner } from "reactstrap"

function CustomSpinner() {
  // ** Hooks
  return (
    <React.Fragment>
          <Spinner color="primary" style={{ margin:"35px", width: "80px", height: "80px"}} />
    </React.Fragment>
  )
}

export default CustomSpinner

